import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { TreeView } from "@mui/x-tree-view/TreeView";

import {
  ProcessModelFolderType,
  RevisionModelType,
  SelectedProcessModelType,
} from "model/processModel";

import ProcessModel from "../ProcessModel";

import TreeItem from "./TreeItem";
import { Box } from "@mui/system";
import InputPopUp from "components/dialogs/InputPopUp";
import { processmodelsApi } from "api";
import { useSnackbar, useTranslations } from "hooks";
import { clearLanes, getTranslation } from "common/utilities";
import { Button, ClickAwayListener } from "@mui/material";

interface handleUpdateTreeFunctionPropsType {
  parentId: Number | null;
  childId: string;
  childName?: string;
  isProcessModel?: Boolean;
  deleteProcessFromFolder?: Boolean;
}

interface TreeViewPropsType {
  scrollContainerRef: React.RefObject<HTMLDivElement>;
  highlighted: number | null;
  processModelFolders: Array<ProcessModelFolderType>;
  processModelList?: SelectedProcessModelType[];
  expandedNodes: string[];
  selectedRevision: RevisionModelType | null;
  setSelectedRevision: React.Dispatch<
    React.SetStateAction<RevisionModelType | null>
  >;
  selectedProcessModel: SelectedProcessModelType | null;
  setSelectedProcessModel: React.Dispatch<
    React.SetStateAction<SelectedProcessModelType | null>
  >;
  returnmodel: (
    model: SelectedProcessModelType,
    errorsInModel: Boolean
  ) => void;
  handleUpdateTree: ({
    parentId,
    childId,
    childName,
    isProcessModel,
    deleteProcessFromFolder,
  }: handleUpdateTreeFunctionPropsType) => void;
  setSelectedNode: React.Dispatch<React.SetStateAction<Number | null | undefined>>;
  handleUpdateFolderName?: (val: string, parentId?: Number) => void;
  handleOnClickDeleteFolderIcon?: (val: Number) => void;
  setExpandedNode: (val: Number) => void;
}

const TreeViewComponent: React.FC<TreeViewPropsType> = ({
  scrollContainerRef,
  selectedProcessModel,
  setSelectedProcessModel,
  selectedRevision,
  setSelectedRevision,
  processModelFolders,
  highlighted,
  processModelList,
  returnmodel,
  handleUpdateTree,
  setSelectedNode,
  handleUpdateFolderName,
  handleOnClickDeleteFolderIcon,
  setExpandedNode,
  expandedNodes,
}) => {
  const handleDrop = (
    event: React.DragEvent<HTMLDivElement>,
    isProcessModel = false
  ) => {
    event.preventDefault();
    event.stopPropagation();
    const obj = JSON.parse(event.dataTransfer.getData("text/plain"));
    handleUpdateTree({
      parentId: obj.isProcessModel ? obj.parentId : null,
      childId: obj.childId,
      childName: obj.childName,
      isProcessModel: obj.isProcessModel || false,
      deleteProcessFromFolder: obj.isProcessModel ? true : false,
    });
    // console.log("parentId", obj.parentId);
  };
  // const eventTarget = useRef<EventTarget | null>(null);
  const handleDragOver = (
    event: React.DragEvent<HTMLDivElement>,
    isProcessModel = false
  ) => {
    event.preventDefault();
    const container = scrollContainerRef.current;
    if (container) {
      const { top, bottom } = container.getBoundingClientRect();
      const mouseY = event.clientY;
      const scrollThreshold = 50;
      const scrollSpeed = 10;

      if (mouseY < top + scrollThreshold) {
        container.scrollTop -= scrollSpeed;
      } else if (mouseY > bottom - scrollThreshold) {
        container.scrollTop += scrollSpeed;
      }
    }
  };

  const [exportId, setExportId] = useState<number | null>(null);
  const { sendSnack } = useSnackbar();
  const translations = useTranslations();


  const handleOnNodeSelect = (
    event: React.SyntheticEvent<Element, Event>,
    nodeIds: string[]
  ) => {
    if (nodeIds && nodeIds[0]) {
      setSelectedNode(parseFloat(nodeIds[0]));
      // setSelectedNode(p => p === parseFloat(nodeIds[0]) ? null : parseFloat(nodeIds[0]));
      setExpandedNode(parseFloat(nodeIds[0]));
    }
  };

  const handleClickAway = (event: MouseEvent | TouchEvent) => {
    //uuuuuuhm è un po' una schifezza ma non riesco a trovare un modo migliore per fare sta cosa
    if (
      event.target instanceof HTMLElement &&
      (
        event.target.closest("#create-new-folder-button") ||
        event.target.closest("#save-folder-btn") ||
        event.target.closest("#folder-name")

      )
    ) {
      // console.log("Clicked element id:", event.target.id);
      return;
    }
    setSelectedNode(null);
  };

  const exportModel = async (nameModel: string) => {
    try {
      const { data } = await processmodelsApi.get(`${exportId}`);
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," +
        encodeURIComponent(clearLanes(data.model))
      );
      element.setAttribute("download", `${nameModel}.flw`);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);

      sendSnack({
        message: data.responsemessage,
        type: "success",
      });
    } catch (e) {
      console.error(e);
      sendSnack({ message: getTranslation(translations, "generic.something_went_wrong.caption"), type: "error" });
    }
  };
  return (
    <React.Fragment>
      <InputPopUp
        labels={{
          title: getTranslation(translations, "generic.model_name.caption"),
          inputLabel: getTranslation(translations, "generic.insert_model_name.caption"),
        }}
        callback={exportModel}
        open={Boolean(exportId)}
        onClose={() => setExportId(null)}
      />
      <ClickAwayListener onClickAway={handleClickAway} >
        <TreeView
          sx={{ height: "100%" }}
          aria-label="process models folder navigator"
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          onNodeSelect={handleOnNodeSelect}
          expanded={
            expandedNodes && expandedNodes.length > 0 ? expandedNodes : []
          }
          defaultExpanded={
            expandedNodes && expandedNodes.length > 0 ? expandedNodes : []
          }
          multiSelect
        >
          <Box
            sx={{ height: "100%", display: "flex", flexDirection: "column", pb: 10, paddingTop: 5 }}
            onDrop={handleDrop}
            onFocusCapture={(e) => e.stopPropagation()}
            onDragOver={handleDragOver}
          >
            {processModelFolders &&
              processModelFolders.map(
                (item) =>
                  Boolean(item && item.id && item.name) && (
                    //  <React.Fragment key={item.id}>
                    <TreeItem
                      selectedProcessModel={selectedProcessModel}
                      setSelectedProcessModel={setSelectedProcessModel}
                      selectedRevision={selectedRevision}
                      setSelectedRevision={setSelectedRevision}
                      onExportClick={() => setExportId(item.id)}
                      highlighted={highlighted}
                      handleUpdateTree={handleUpdateTree}
                      key={item.id}
                      nodes={item}
                      processModelList={processModelList}
                      returnmodel={returnmodel}
                      handleUpdateFolderName={handleUpdateFolderName}
                      handleOnClickDeleteFolderIcon={
                        handleOnClickDeleteFolderIcon
                      }
                    />
                    // </React.Fragment>
                  )
              )}
            <Box
              sx={{ height: "100%" }}
              onFocusCapture={(e) => e.stopPropagation()}
              onDragOver={(e) => handleDragOver(e, true)}
              onDrop={(e) => handleDrop(e, true)}
            >
              {processModelList?.map(
                (model: SelectedProcessModelType, index: number) =>
                  Boolean(model.id && !model.idfolder) && (
                    <ProcessModel
                      selectedProcessModel={selectedProcessModel}
                      setSelectedProcessModel={setSelectedProcessModel}
                      selectedRevision={selectedRevision}
                      setSelectedRevision={setSelectedRevision}
                      onExportClick={() => setExportId(model.id)}
                      highlighted={highlighted}
                      key={model.id}
                      model={model}
                      index={index}
                      returnmodel={returnmodel}
                    />
                  )
              )}
            </Box>
          </Box>
        </TreeView>
      </ClickAwayListener>
    </React.Fragment>
  );
};

export default TreeViewComponent;
